import {
  HIDE_ARTICLE_PREMIUM_UPGRADE_BANNER,
  HIDE_INTELLIGENCE_SOLUTIONS_BANNER
} from "@/src/sb/constants"
import { useEffect } from "react"

export const SESSION_ONLY_KEYS = [
  HIDE_ARTICLE_PREMIUM_UPGRADE_BANNER,
  HIDE_INTELLIGENCE_SOLUTIONS_BANNER
]

const useClearSession = () => {
  useEffect(() => {
    // Clear storage keys meant only for a single session
    for (const key of SESSION_ONLY_KEYS) {
      localStorage.removeItem(key)
    }
  }, [])
}

export default useClearSession
